<template>
  <div style="overflow-y: hidden !important; height: 100vh !important">
    <div class="background indigo">
      <div class="container">
        <div class="container">
          <div class="center white-text" v-if="currentStep != 0">
            <h4>Evaluado: {{ displayTitle }}</h4>
          </div>

          <Login v-if="currentStep == 0" @nextStep="nextStep" />
          <Info v-if="currentStep == 1" @nextStep="nextStep" />
          <Instructions v-if="currentStep == 2" @nextStep="nextStep" />
          <Questionnaire
            v-if="currentStep == 3"
            @nextStep="nextStep"
            :reactives="reactives"
          />
          <Finish v-if="currentStep == 4" @nextStep="nextStep" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";

import axios from "axios";
//steps
import Login from "./questionnaireSteps/login.vue";
import Info from "./questionnaireSteps/info.vue";
import Instructions from "./questionnaireSteps/instructions.vue";
import Questionnaire from "./questionnaireSteps/questionnaire.vue";
import Finish from "./questionnaireSteps/finish.vue";

export default {
  components: {
    Login,
    Info,
    Instructions,
    Questionnaire,
    Finish,
  },
  data() {
    return {
      // questionnaire data
      user: this.$route.params.user,
      title: this.$route.params.campainName,
      displayTitle: this.urlToString(this.$route.params.campain).toUpperCase(),
      questionnaireStatus: false,

      // user data
      entitie: "",
      area: "",
      turn: "",
      gender: "",
      age: "",
      antiquity: "",
      studies: "",
      suggestion: "",

      // questionnaire reactives
      reactives: [],
      aspectsList: {},
      aspectsTotalList: {},
      stopSetInterval: false,
      finish: false,
      isCounted: true,
      questionStarted: true,

      // access data
      userCodeStatus: false,
      userEmail: "",
      userCode: "",
      serverCode: "",

      //finish questionnaire
      calculatedAspects: {},
      questionnaireStarted: false,

      // extra data
      campains: 0,
      response: "",

      // evaluador

      evaluator: {},

      currentStep: 0,
    };
  },
  methods: {
    nextStep() {
      this.currentStep++;
    },
    get() {
      axios
        .get(
          "https://evaluacion-360.human-express.com/php/evaluations/read.php?query=*&campain=" +
            this.displayTitle +
            "&user=" +
            this.user
        )
        .then((response) => {
          response.data.reactives.forEach((question) => {
            question.status = 0;
          });
          var reactives = response.data.reactives.reverse();
          reactives[0].status = 1;
          this.reactives = reactives;
          this.updateReactivesLength(response.data.reactives.length);
          this.campains = response.data.campains;

          let campains = JSON.parse(this.campains.campains);
          campains.forEach((campain) => {
            if (campain.name.toLowerCase() == this.displayTitle.toLowerCase()) {
              this.updateThisCampain(campain);
              this.questionnaireStatus = campain.status;
            }
          });
        });
    },

    urlToString(string) {
      return string.replace(/-/g, " ");
    },
    ...mapMutations(["updateThisCampain", "updateReactivesLength"]),
  },
  mounted() {
    this.get();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/questionnaire/questionnaire.vue